<template>
  <span
    v-if="isPageIconShown"
    class="page-icon-wrapper"
  >
    <img
      v-if="isImage"
      :src="generateUrl(pageIconSrc)"
      alt="page icon"
      height="16"
      width="16"
      class="object-cover page-icon flex"
      :class="classes"
    />
    <EmojiIcon
      v-else-if="isEmoji"
      :emoji="pageIconSrc"
      :classes="`flex justify-center items-center page-icon ${classes}`"
      :class="classes"
      :style="emojiStyle"
      :custom-style="customStyle"
    />
    <em
      v-else-if="isIcon"
      class="custom-icons page-icon"
      :style="[
        getCustomIconStyle(iconPath(pageIconSrc)),
        { background: pageIconColor, display: 'flex' },
      ]"
      :class="`flex justify-center items-center page-icon ${classes}`"
      >&nbsp;</em
    >
    <em
      v-else-if="showDefaultIcon"
      class="custom-icons page-icon bg-icon-default flex"
      :style="[getCustomIconStyle(isDraftPage ? iconPath('file') : iconPath('page'))]"
      :class="`flex justify-center items-center page-icon ${classes}`"
      >&nbsp;</em
    >
  </span>
</template>

<script>
import EmojiIcon from '@/components/functional/EmojiIcon.vue';
import generateSrcUrl from '@/utilities/generateSrcUrl';
import customIconsMixin from '@/mixins/customIconsMixin';

export default {
  name: 'PageIcon',

  components: { EmojiIcon },

  mixins: [customIconsMixin],

  props: {
    pageId: {
      type: String,
      required: false,
      default: '',
    },
    classes: {
      type: String,
      required: false,
      default: '',
    },
    storeRef: {
      type: Object,
      required: false,
      default: () => null,
    },
    customStyle: {
      type: Object,
      required: false,
      default: () => {},
    },
    showDefaultIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    propIcon: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    isIcon() {
      return [this.page?.icon?.type, this.propIcon?.type].includes(this.iconEnum);
    },

    isEmoji() {
      return [this.page?.icon?.type, this.propIcon?.type].includes(this.emojiEnum);
    },

    isImage() {
      return (
        [this.page?.icon?.type, this.propIcon?.type].includes(this.imageEnum) ||
        (this.page?.icon?.type === '' && this.page?.icon?.src !== '') ||
        (this.propIcon?.type === '' && this.propIcon?.src !== '')
      );
    },

    pageIconSrc() {
      return this.page?.icon?.src || this.propIcon?.src || '';
    },

    pageIconColor() {
      return this.page?.icon?.color || this.propIcon?.color || '';
    },

    isDraftPage() {
      return this.sidebarDraftPage.id === this.pageId;
    },

    sidebarDraftPage() {
      return this.store.getters.sidebarDraftPage;
    },

    store() {
      return this.storeRef || this.$store;
    },

    page() {
      return (
        this.store.getters.getPageById(this.pageId) ||
        this.store.getters.archivePages[this.pageId] ||
        {}
      );
    },

    emojiStyle() {
      return {
        width: '16px',
        height: '16px',
        fontSize: '16px',
        ...this.customStyle,
      };
    },

    isPageIconShown() {
      return this.isIcon || this.isEmoji || this.isImage || this.showDefaultIcon;
    },
  },

  created() {
    this.setIconType();
  },

  methods: {
    generateUrl(src) {
      return generateSrcUrl(src, 16, 16, true);
    },
    setIconType() {
      const { icon } = this.page || {};
      if ((!icon?.type || icon?.type === '') && icon?.src) {
        this.store.dispatch('localUpdatePageProp', {
          pageId: this.pageId,
          propertyName: 'icon',
          value: {
            ...icon,
            type: this.imageEnum,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss">
.page-icon {
  min-width: 16px;
  margin-right: 8px;
  @apply w-4 h-4;
}
</style>
